import { useRef, Fragment } from 'react';
import oxeappImage from '../assets/Portfolio/logo-placeholder.png';
import mintingDappImage from '../assets/Portfolio/minting-dapp00.png';
import qsatTokenImage from '../assets/Portfolio/qsat-token-brc20.jpg';
import agoraValleysImage from '../assets/Portfolio/agoravalleys.png';
import phemeImage from '../assets/Portfolio/pheme-logo.svg';

const Portfolio = () => {
  const carouselRef = useRef(null);

  const scrollCarousel = (direction) => {
    const container = carouselRef.current;
    if (!container) {
      return;
    }

    const scrollAmount = container.clientWidth * 0.85;
    container.scrollBy({
      left: direction === 'next' ? scrollAmount : -scrollAmount,
      behavior: 'smooth'
    });
  };

  const portfolioGroups = [
    {
      groupName: 'Platform',
      projects: [
        {
          id: 1,
          title: 'OXEChain',
          description: 'Referral system & Next-generation blockchain engagement platform with gamified experiences',
          url: 'https://oxechain.com',
          category: 'Web3',
          tags: ['Blockchain', 'Engagement', 'Web3'],
          image: oxeappImage
        }
      ]
    },
    {
      groupName: 'Marketplace',
      projects: [
        {
          id: 2,
          title: 'Agora Valleys',
          description: 'Behavioral & reputation agent marketplace. Agents carry on-chain identity (Aetos ID) and are hired on verified track record, not claims. Live skills marketplace powered by PHEME intelligence signals.',
          url: 'https://agoravalleys.com',
          category: 'Web3',
          tags: ['Agent Marketplace', 'On-Chain Identity', 'MCP', 'Claude SDK'],
          image: agoraValleysImage
        },
        {
          id: 6,
          title: 'PHEME',
          description: 'Market intelligence engine that scores crypto news by AI and weights it against live Polymarket prediction-confidence. Ships as an MCP server with 8+ live tools (pheme_regime, pheme_market_brief, pheme_macro_context, and more) for agents, plus a Telegram feed for humans.',
          url: 'https://pheme.quanturama.com',
          category: 'Web3',
          tags: ['MCP', 'Market Intelligence', 'Polymarket', 'AI Agents'],
          image: phemeImage
        }
      ]
    },
    {
      groupName: 'NFT Projects',
      projects: [
        {
          id: 4,
          title: 'Minting DApp',
          description: 'Decentralized minting platform for creating and deploying NFT collections',
          url: 'https://rarible.com/token/polygon/0x5f1686d96d43769001e6c6a5272b7a5f16be0294:93632328000829882291443493095780839453455736989865351835727459282661062737922',
          category: 'Web3',
          tags: ['Minting', 'DApp', 'Smart Contracts'],
          image: mintingDappImage
        },
        {
          id: 5,
          title: 'QSAT Token',
          description: 'BRC-20 token ecosystem with multi-chain support and utility features',
          url: 'https://oxechain.xyz',
          category: 'Tokens',
          tags: ['BRC-20', 'Token', 'Blockchain'],
          image: qsatTokenImage
        }
      ]
    },
  ];

  return (
    <section className="portfolio-section" id="portfolio">
      <div className="portfolio-container">
        <div className="section-header">
          <h2 className="section-title">
            Featured <span className="gradient-text">Projects</span>
          </h2>
          <p className="section-subtitle">
            Production systems and platforms shipped for real operators.
          </p>
        </div>

        <div className="portfolio-carousel">
          <button
            type="button"
            className="portfolio-carousel-btn prev"
            aria-label="Previous projects"
            onClick={() => scrollCarousel('prev')}
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M15 6L9 12L15 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <div className="portfolio-grid portfolio-carousel-track" ref={carouselRef}>
            {portfolioGroups.map((group, groupIndex) => (
              <Fragment key={groupIndex}>
                {group.projects.map((project) => (
                  <div key={project.id} className="portfolio-card">
                    <div className="portfolio-card-header">
                      <span className="portfolio-category">{project.category}</span>
                    </div>

                    {project.image && (
                      <div className="portfolio-image-container">
                        <img src={project.image} alt={project.title} className="portfolio-image" />
                      </div>
                    )}

                    <div className="portfolio-card-content">
                      <h3 className="portfolio-title">{project.title}</h3>
                      <p className="portfolio-description">{project.description}</p>

                      <div className="portfolio-tags">
                        {project.tags.map((tag, index) => (
                          <span key={index} className="portfolio-tag">{tag}</span>
                        ))}
                      </div>
                    </div>

                    <div className="portfolio-card-footer">
                      <a
                        href={project.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="portfolio-link"
                      >
                        <span>View Project</span>
                        <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </div>

                    <div className="portfolio-folder-label">
                      <span className="folder-name">...{group.groupName}</span>
                    </div>
                  </div>
                ))}
              </Fragment>
            ))}
          </div>

          <button
            type="button"
            className="portfolio-carousel-btn next"
            aria-label="Next projects"
            onClick={() => scrollCarousel('next')}
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

      </div>
    </section>
  );
};

export default Portfolio;
